export default "__VITE_ASSET__COGA6GF1__"